import {
    amazon_choice__pct,
    amazon_choice_count,
    best_seller__pct,
    best_seller_count,
    brand_amazon_choice__pct,
    brand_amazon_choice_count,
    brand_best_seller__pct,
    brand_best_seller_count,
    brand_count,
    brand_count__pct,
    brand_fold_weight__pct,
    brand_fold_weight__sum,
    brand_organic__pct,
    brand_organic_count,
    brand_rank_weight__pct,
    brand_rank_weight__sum,
    brand_sponsored__pct,
    brand_sponsored_brands__pct,
    brand_sponsored_brands_count,
    brand_sponsored_count,
    brand_sponsored_products__pct,
    brand_sponsored_products_count,
    cost__sum,
    count,
    count__pct,
    estimated_cost_of_all_sponsored,
    estimated_search_volume,
    fold_weight__pct,
    impressions__sum,
    local_rank__avg,
    organic_count,
    rank__avg,
    rank_weight__pct,
    review_star__avg,
    sponsored_brands_count,
    sponsored_count,
    sponsored_products_count,
} from 'configuration/fieldCreators/metrics/sov'
import { productLabelId } from 'configuration/fieldCreators/productMetadata'
import {
    amazonChoice,
    badgesJson,
    bestSeller,
    layout,
    resultType,
    searchTimeDay,
    searchTimeMonth,
    searchTimeWeek,
    searchTimeWeekDay,
    searchTimeYear,
    sovKeywordCountryCode,
    sovKeywordId,
    sovKeywordLabelId,
    sovKeywordLanguageCode,
    sovKeywordPlatform,
    sovKeywordResearchName,
} from 'configuration/fieldCreators/sov'

import { makeMapping } from './helpers'

export const SOV_METRICS_COLUMNS_PAGES = [
    count(),
    count__pct(),
    rank_weight__pct(),
    fold_weight__pct(),
    brand_count(),
    brand_count__pct({ isVisible: true }),
    brand_rank_weight__pct({ isVisible: true }),
    brand_fold_weight__pct({ isVisible: true }),
    estimated_search_volume(),
    rank__avg(),
    local_rank__avg(),
    review_star__avg(),
    amazon_choice_count(),
    amazon_choice__pct(),
    best_seller_count(),
    best_seller__pct(),
    brand_amazon_choice_count(),
    brand_amazon_choice__pct(),
    brand_best_seller_count(),
    brand_best_seller__pct(),
    sponsored_products_count(),
    sponsored_brands_count(),
    sponsored_count(),
    organic_count(),
    brand_sponsored_products_count(),
    brand_sponsored_brands_count(),
    brand_sponsored_count(),
    brand_organic_count(),
    brand_sponsored_products__pct(),
    brand_sponsored_brands__pct(),
    brand_sponsored__pct(),
    brand_organic__pct(),
    cost__sum(),
    impressions__sum(),
    estimated_cost_of_all_sponsored(),
]

const SOV_BRAND_METRICS_COLUMNS = [
    brand_count({ isVisible: true }),
    brand_count__pct({ isVisible: true }),
    brand_rank_weight__pct({ isVisible: true }),
    brand_fold_weight__pct({ isVisible: true }),
    brand_amazon_choice__pct({ isVisible: true }),
    brand_best_seller__pct({ isVisible: true }),
    brand_rank_weight__sum({ isVisible: true }),
    brand_fold_weight__sum({ isVisible: true }),
    brand_sponsored_products_count({ isVisible: true }),
    brand_sponsored_brands_count({ isVisible: true }),
    brand_sponsored_count({ isVisible: true }),
    brand_organic_count({ isVisible: true }),
    brand_sponsored_products__pct({ isVisible: true }),
    brand_sponsored_brands__pct({ isVisible: true }),
    brand_sponsored__pct({ isVisible: true }),
    brand_organic__pct({ isVisible: true }),
    estimated_cost_of_all_sponsored({ isVisible: true }),
]

export const SOV_BRAND_METRICS_CONFIG = makeMapping(SOV_BRAND_METRICS_COLUMNS)

export const SPECIAL_SOV_INTRADAY_GROUP_BY_COLUMNS = [
    sovKeywordId(),
    sovKeywordPlatform(),
    sovKeywordCountryCode(),
    sovKeywordLanguageCode(),
    sovKeywordLabelId(),
    resultType(),
    productLabelId(),
    amazonChoice(),
    bestSeller(),
    badgesJson(),
    layout(),
    searchTimeDay(),
    searchTimeWeek(),
    searchTimeWeekDay(),
    searchTimeMonth(),
    searchTimeYear(),
]

export const SPECIAL_SOV_KEYWORD_RESEARCH_GROUP_BY_COLUMNS = [
    sovKeywordResearchName({ dataIndex: ['name'] }),
]

export const SOV_TIME_AGGREGATE_COLUMNS = [
    searchTimeDay(),
    searchTimeWeek(),
    searchTimeMonth(),
]
